<template>
  <div class="space-y-10">
    <section class="space-y-6">
      <div>
        <h1 class="text-3xl font-bold mb-2">Dashboard Geral</h1>
        <p class="text-muted-foreground">Visão geral dos principais indicadores 2026</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <KPICard
          v-for="kpi in geralDefs"
          :key="kpi.key"
          :title="kpi.name"
          :meta="kpi.metas[currentMonthIndex] || 0"
          :realizado="getCurrentMonthRealizado('geral', kpi.key)"
          :format="kpi.format"
        />
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <KPIChartCard
          v-for="kpi in geralDefs"
          :key="kpi.key"
          sector="geral"
          :kpiKey="kpi.key"
          :kpiName="kpi.name"
          :metas="kpi.metas"
          :format="kpi.format"
          :readonly="isEmbedReadonly"
        />
      </div>
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="comercial"
        title="Comercial"
        subtitle="Gestão de vendas, faturamento e conversões"
      />
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="marketing"
        title="Marketing"
        subtitle="Gestão de investimentos, leads e custos de aquisição"
      />
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="operacoes"
        title="Operações"
        subtitle="Gestão de prazos de envio e logística operacional"
      />
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="compras"
        title="Compras"
        subtitle="Gestão de economias, aquisições e prazos"
      />
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="sucesso"
        title="Sucesso do Cliente"
        subtitle="Gestão de NPS e tempo de atendimento"
      />
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="ti"
        title="TI"
        subtitle="Gestão de prejuízo evitado, despesas e receita por IA"
      />
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="logistica"
        title="Logística"
        subtitle="Gestão de savings e turmas atendidas"
      />
    </section>

    <section class="space-y-6">
      <SectorDashboard
        sector="academico"
        title="Acadêmico"
        subtitle="Gestão de inscrições, conversão e prazos"
      />
    </section>
  </div>
</template>

<script>
import KPICard from '@/components/kpi/KPICard.vue'
import KPIChartCard from '@/components/kpi/KPIChartCard.vue'
import SectorDashboard from '@/views/SectorDashboard.vue'
import { months } from '@/lib/kpi-data'

export default {
  name: 'DashboardGeral',
  components: { KPICard, KPIChartCard, SectorDashboard },
  computed: {
    isEmbedReadonly() {
      return Boolean(this.$route && this.$route.meta && this.$route.meta.readonly)
    },
    kpisData() {
      return this.$store.state.kpis.data || {}
    },
    currentMonthIndex() {
      return new Date().getMonth()
    },
    geralDefs() {
      const defs = this.$store.getters['kpis/getDefsForSector']('geral') || []
      return defs.map((d) => ({
        ...d,
        metas: months.map((m) => Number(this.kpisData?.geral?.[d.key]?.[m]?.meta ?? 0)),
      }))
    },
  },
  methods: {
    getCurrentMonthRealizado(sector, kpiKey) {
      const idx = new Date().getMonth()
      const month = months[idx]
      return Number(this.kpisData?.[sector]?.[kpiKey]?.[month]?.realizado ?? 0)
    },
  },
}
</script>

